const SemVer = require('../classes/semver')
const patch = (a, loose) => new SemVer(a, loose).patch
module.exports = patch



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/patch.js
// module id = 1416
// module chunks = 0